import type { FaireProductEntity } from "../../entity_types/product";

export const p_d3knfhp4cp: FaireProductEntity = {
  token: "p_d3knfhp4cp",
  type: "product",
  name: "30 Shower Steamers, Bath Bomb, Shower Steamer",
  brandToken: "b_chkchzbnrw",
  brandName: "Subtle & Wild",
  imageUrl:
    "https://cdn.faire.com/fastly/59f78efdb7a54d3928e6fd1025c8dd665e9c1a0dfc94c765300788650811d898.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/16f44eb8770bace658aad651c16ccbdcea95b91c2c12445ef15c73a33bd435dc.jpeg",
    "https://cdn.faire.com/fastly/d1013f90634e755e904728bd490edf9a92b9264959f6bd8792fe1e5c4f356f01.jpeg",
    "https://cdn.faire.com/fastly/7aea05dea0d26a806bdde5cd2366258429b74f4edcb86fed367e9b23845bb9ea.jpeg",
    "https://cdn.faire.com/fastly/6d8072db48dab5f332c35d713b1aa4b645aea76e1e4fffcd4a7dd6aba98f3547.jpeg",
    "https://cdn.faire.com/fastly/d1f17d93e7ec75fcfee688a44abd06a21118eff541d2b1812b716a116b107dd6.jpeg",
    "https://cdn.faire.com/fastly/f3f4bbca76be30976619c4c084ff62054ea4fa7b60b4aca021b0d8d1fed11ab8.jpeg",
    "https://cdn.faire.com/fastly/1ffb15af96f40e8c8b4b15f098a153ed8051d719495c8180b47969467a2a05aa.jpeg",
    "https://cdn.faire.com/fastly/9f36da1fdf07b8fe604b66aba93ff6f33d7d37fcdd0d4dcdabc2c5c5a8edcc67.jpeg",
  ],
  priceDollars: 1.5,
  description:
    "You’ll get 30 shower steamers for this price. We have reduced plastic drastically by not having the shower steamers individually wrapped.\nPlease look at the last picture to see an example of how shower steamers are shrink-wrapped.\n\n𝐓𝐨 𝐔𝐬𝐞:\nTurn your shower into a spa by using one of our shower steamers. Lay this tablet on the bottom floor of your shower and turn your water to its hottest setting while closing the door of your bathroom. Allow the tablet to dissolve halfway before entering the shower. Do not put shower steamer directly into the water stream because it needs steam in order to dissolve the proper way.\n\nThis would make the perfect gift for anyone, or even bridal shower favors as well. You will get to select your scent at check out. Our variety set includes random fragrances that we have in stock at the moment.\n\n𝐈𝐧𝐠𝐫𝐞𝐝𝐢𝐞𝐧𝐭𝐬:\nbaking soda, citrus acid, cornstarch, distilled water, fragrance oils, Epsom salt, Almond oil",
  tags: [],
  msrpDollars: 3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:04.112Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
